// The auto-assigned new-member "bonus" courses (BE CleNewMemberDummyCourseRule, Bug 2252): hours the
// Bar grants a new admittee, not a course the attorney took. Their real course records carry internal
// titles, so every attorney course list shows them under this one label, with no sponsor line.
// Decided 2026-10-28 — replaces hiding them on the TILPP screen.

import { CheckCLESettings } from '../../_core/models/cle-check.models';

export const NEW_MEMBER_BONUS_COURSE_TITLE = 'New Members Bonus CLE Hours';

/** The configured (non-zero) bonus course ids from /cle/checkcle/settings. 0 = that size is not configured
 *  for this environment and must never match a real course. Empty when settings have not loaded or failed,
 *  so rows then show their stored title rather than a wrong guess. */
export function newMemberBonusCourseIds(settings: CheckCLESettings | null | undefined): Set<number> {
  return new Set(
    [
      settings?.newMemberDummyCourse6Id,
      settings?.newMemberDummyCourse9Id,
      settings?.newMemberDummyCourse18Id,
    ]
      .map(id => Number(id) || 0)
      .filter(id => id > 0)
  );
}
